<template>
  <!-- Main Sidebar Container -->
  <aside class="main-sidebar sidebar-light-secondary elevation-0">

    <!-- Brand Logo -->
    <router-link to="/dashboard" class="brand-link">
      <!-- <img src="/logo.svg" alt class="brand-image img-circle elevation-3" /> -->
      <span class="ml-3 brand-text text-info font-weight-bold">OwnaRadio</span>
    </router-link>
    <!-- Sidebar -->
    <div class="sidebar">
      <!-- <h5 class=" pt-3 pl-4 font-weight-bold text-success">{{selectedStation.name}}</h5>
      <hr>-->
      <multiselect
        :options="stationData"
        v-model="selectedStation"
        :searchable="true"
        :show-labels="false"
        :allow-empty="false"
        :hide-selected="true"
        :loading="processing"
        label="name"
        track-by="id"
      ></multiselect>
      <!-- Sidebar user panel (optional) -->

      <div class="mt-3 pb-3 mb-3 d-flex">
        <button
          @click.prevent="$eventHub.$emit('player_toggle')"
          class="btn btn-sm"
        >
          <i
            class="fas fa-3x mx-auto text-info"
            :class="
              this.$store.state.isPlaying ? 'fa-stop-circle' : 'fa-play-circle'
            "
          ></i>
        </button>

        <template v-if="onAir">
          <button
            class="btn btn-sm btn-danger px-5 badge badge-pill p-3 mx-3"
            data-toggle="dropdown"
            :disabled="status.processing"
            v-text="status.processing ? 'Stopping...' : 'ON AIR'"
          ></button>
          <div class="dropdown-menu dropdown-menu-sm dropdown-menu-right">
            <div class="px-2 py-2">
              <h6 class="text-muted text-center small">Turn it off?</h6>
              <div class="dropdown-divider"></div>
              <div class="btn-group" role="group">
                <button
                  @click="serverAction(stopUri, 'processing')"
                  type="button"
                  class="btn btn-danger"
                >
                  Yes
                </button>
                <button type="button" class="btn btn-default">Cancel</button>
              </div>
            </div>
          </div>
        </template>

        <template v-else>
          <button
            class="step-4 btn btn-sm btn-secondary px-5 badge badge-pill p-3 mx-3"
            @click="serverAction(startUri, 'processing')"
            :disabled="status.processing"
            v-text="status.processing ? 'Starting...' : 'OFF AIR'"
          >
            OFF AIR
          </button>
        </template>
      </div>
            <button
            v-if="station.needs_restart"
            @click="serverAction(reloadUri, 'reloading')"
            class="btn btn-sm mr-2"
          >
            <i class="fas fa-redo-alt"></i>
            {{status.reloading? 'reload...':'Reload to Apply Changes'}}
          </button>
      <hr />
      <div class="px-3" v-if="onAir">
        <span>
          <small class="text-info font-weight-bold">
            Now Playing:
            <br />
          </small>
          {{ current_track.text }}
          <br />
        </span>
        <span>
          <small class="text-info font-weight-bold">Listeners:</small>
          <span>{{ listeners.unique }}</span>
        </span>
      </div>

      <!-- Sidebar Menu -->
      <nav class="mt-2 mb-5">
        <ul
          class="sidebar-menu nav nav-pills nav-sidebar flex-column"
          data-expand-sidebar="true"
          data-widget="treeview"
          role="menu"
          data-accordion="true"
        >
          <template v-for="(item, i) in menu">
            <li v-if="item.child" class="nav-item has-treeview" :key="i">
              <a href="#" class="nav-link">
                <i :class="item.icon"></i>
                <p>
                  {{ item.name }}
                  <i class="right fas fa-angle-left"></i>
                </p>
              </a>
              <ul class="nav nav-treeview">
                <template v-for="(child, i) in item.child">
                  <li v-if="child.external" class="nav-item" :key="i">
                 <a
                :href="`${BASE_URL}/${child.link}/${stationId}-${station.short_name}`"
                class="nav-link"
                target="_blank"
              >
                <i :class="child.icon"></i>
                <p>
                  {{ child.name }}
                  <i class="fas fa-external-link-alt nav-icon right"></i>
                </p>
              </a>
                </li>

                 <li v-else class="nav-item" :key="i">
                  <router-link
                    :data-widget="isMobile() ? 'pushmenu' : ''"
                    :data-auto-collapse-size="isMobile() ? 768 : ''"
                    :to="child.link"
                    class="nav-link"
                  >
                    <i :class="child.icon"></i>
                    <p>{{ child.name }}</p>
                  </router-link>
                </li>
                </template>
              </ul>
            </li>

            <li v-else-if="item.external" class="nav-item" :key="i">
              <a
                :href="`${BASE_URL}/${item.link}/${stationId}-${station.short_name}`"
                class="nav-link"
                target="_blank"
              >
                <i :class="item.icon"></i>
                <p>
                  {{ item.name }}
                  <i class="fas fa-external-link-alt nav-icon right"></i>
                         <div id="v-step-0">A DOM element on your page. The first step will pop on this element because its ID is 'v-step-0'.</div>
                </p>
              </a>
            </li>

            <!-- <li v-else v-show="gate.canAny(item.permissions)" class="nav-item" :key="i">  -->
              <li v-else-if="item.tour" class="step-1 nav-item" :key="i">
              <router-link
                :data-widget="isMobile() ? 'pushmenu' : ''"
                :data-auto-collapse-size="isMobile() ? 768 : ''"
                :to="item.link"
                class="nav-link"
              >
                <i :class="item.icon"></i>
                <p>{{ item.name }}</p>
              </router-link>
            </li>

            <li v-else class="nav-item" :key="i">
              <router-link
                :data-widget="isMobile() ? 'pushmenu' : ''"
                :data-auto-collapse-size="isMobile() ? 768 : ''"
                :to="item.link"
                class="nav-link"
              >
                <i :class="item.icon"></i>
                <p>{{ item.name }}</p>
              </router-link>
            </li>
          </template>
        </ul>
      </nav>
      <!-- /.sidebar-menu -->
    </div>
    <!-- /.sidebar -->
  </aside>
  <!-- /.navbar -->
</template>
<script>
import Multiselect from "vue-multiselect";
import { FETCH_STATION_INFO } from "@/store/action-types";
import { SELECT_STATION } from "@/store/mutation-types";
import { isMobile } from "@/plugins/utils";
import ServerActionMixin from "@/plugins/mixins/serverAction";

export default {
  components: {
    Multiselect,
  },
  mixins: [ServerActionMixin],

  computed: {
    selectedStation: {
      get() {
        return this.$store.state.stations.selectedStation;
      },
      set(station) {
        this.$eventHub.$emit("player_stopped");
        if (station.id === 0) {
          location.href = `${this.BASE_URL}/pricing`;
          return;
        }
        this.$store.commit(SELECT_STATION, station);
        this.$store.dispatch(FETCH_STATION_INFO, {
          id: this.stationId,
          repeat: false,
        });
      },
    },

    stationData() {
      // const add = { name: "+ Create New Station", id: 0 };
      // return [...this.authUser.stations, add];

      return this.authUser.stations;
    },
  },

  // created() {
  //   this.setupStream();
  // },

  mounted() {
    //treeview wont work without this code
    $('[data-widget="treeview"]').Treeview("init");
  },

  methods: {
    isMobile,


    // setupStream() {
    //   let evtSource = new EventSource(
    //     process.env.VUE_APP_API_URL + "getEventStream"
    //   );
    //   console.log(evtSource);
      // evtSource.onmessage = function (e) {
      //   let data = JSON.parse(e.data);
      //   console.log(data);

      //   evtSource.close();
      // };

      // evtSource.addEventListener(
      //   "ping",
      //   function (e) {
      //     let data = JSON.parse(e.data);
      //     console.log(data);

      //     //evtSource.close(); //close the connection
      //   },
      //   false
      // );
    // },
  },
  

  data() {
    return {
      menu: [
        {
          name: "Dashboard",
          link: "/dashboard",
          icon: "fas fa-tachometer-alt nav-icon text-success",
          permissions: ["view_dashboard"],
        },

        {
          name: "Audio Files",
          link: "/files",
          tour: true,
          icon: "nav-icon fas fa-users text-info",
          permissions: [""],
        },

         {
          name: "Go Live",
          icon: "nav-icon fas fa-users text-danger",
          permissions: [""],
          child: [
              {
              name: "Web DJ",
              external: true,
              link: "web-dj",
              icon: "fas fa-circle nav-icon text-danger",
              permissions: [""],
            },
            {
              name: "Broadcast Detail",
              link: "/go-live",
              icon: "fas fa-circle nav-icon text-success",
              permissions: [""],
            },
            {
              name: "Streaming Control",
              link: "/streaming-control",
              icon: "fas fa-sliders-h nav-icon text-warning",
              permissions: [""],
            },
          ],
        },

  

        {
          name: "Playlists",
          icon: "nav-icon fas fa-users text-success",
          permissions: [""],
          child: [
            {
              name: "Playlists",
              link: "/playlists",
              icon: "fas fa-circle nav-icon",
              permissions: [""],
            },
            // {
            //   name: "Schedule",
            //   link: "/schedules",
            //   icon: "fas fa-circle nav-icon",
            //   permissions: [""],
            // },
          ],
        },

        {
          name: "Share",
          link: "/share",
          icon: "fas fa-share nav-icon text-info",
          permissions: [""],
        },

        {
          name: "Analytics",
          icon: "nav-icon fas fa-chart-bar text-secondary",
          permissions: [],
          child: [
            {
              name: "Overview",
              link: "/overview",
              icon: "fas fa-circle nav-icon",
              permissions: [""],
            },
            {
              name: "Real Time",
              link: "/real-time",
              icon: "fas fa-circle nav-icon",
              permissions: [""],
            },
          ],
        },

        // {
        //   name: "User Management",
        //   icon: "nav-icon fas fa-users text-info",
        //   permissions: ["view_users", "view_roles"],
        //   child: [
        //     {
        //       name: "Users",
        //       link: "/users",
        //       icon: "fas fa-circle nav-icon",
        //       permissions: ["view_users"],
        //     },
        //     {
        //       name: "Roles",
        //       link: "/roles",
        //       icon: "fas fa-circle nav-icon",
        //       permissions: ["view_roles"],
        //     },
        //   ],
        // },

        // {
        //   name: "Profile",
        //   link: "/profile",
        //   icon: "nav-icon fas fa-user text-danger",
        //   permissions: [""],
        // },

           {
          name: "Settings",
          link: "/settings",
          icon: "nav-icon fas fa-cog text-warning",
          permissions: [""],
        },
      ],
     
    };
  },
};
</script>

<style scoped>
.dot {
  height: 25px;
  width: 25px;
  background-color: #bbb;
  border-radius: 50%;
  display: inline-block;
}
</style>
